import userStore from '@/store/holder/user-store'

const genericEntities = [
    'userStore',
]

const entities = {
    userStore
}

export {genericEntities}

export default entities
